import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import './ErrorPage.css'

const NotFoundPage = () => {
    const { t } = useTranslation("common");

    return (
        <div className="notfound-container">
            <div className="notfound-content">
                <img
                    src="https://comodosslstore.com/blog/wp-content/uploads/2024/01/website-page-found-error-robot-character-broken-chatbot-mascot-disabled-site-technical-work_502272-1888.jpg"
                    alt={t("notFound.imageAlt", { defaultValue: "Page introuvable" })}
                    className="notfound-image"
                />
                <h1>{t("notFound.title", { defaultValue: "Oups, cette page est introuvable." })}</h1>
                <p>
                    {t("notFound.body", {
                        defaultValue: "Il semble que vous soyez perdu. Pas de panique, on vous remet sur le bon chemin !",
                    })}
                </p>
                <Link to="/workspace" className="notfound-button">
                    {t("notFound.cta", { defaultValue: "Retour à l'accueil" })}
                </Link>
            </div>
        </div>
    );
};

export default NotFoundPage;
